import { Container, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import Page from 'src/components/molecules/page';
import { PlanForm } from 'src/components/organisms/plan/form';

export const PhotoStudioPlanCreatePage: FC = () => {
  /* 定数宣言 */
  const title = 'プラン登録';

  return (
    <Page title={title}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </Stack>
        <PlanForm />
      </Container>
    </Page>
  );
};
